angular.module('unergie.main')
.controller('metaInvoicesCutoffCtrl', ($scope, $location, $stateParams, DataAccess, NgTableParams, FilterMapping, SocketFactory, EventProcessorService,
    DataAccessSearch, ApiBilling, AlertManager, TableGeneratorService, ErrorCatcher, UserNotificationService) => {
    $scope.invoiceStatuses = FilterMapping.invoiceStatuses

    $scope.notNullFilter = [{ id: '!<null>', title: 'Oui' }, { id: '<null>', title: 'Non' }]
    $scope.boolFilter = [{ id: true, title: 'Oui' }, { id: false, title: 'Non' }]

    SocketFactory.join('BO_metaInvoicesCutoff', $scope)

    const lastMonthMoment = moment().add(-1, 'month')
    $scope.cutoffMonth = Number($stateParams.month || lastMonthMoment.format('M'))
    $scope.cutoffYear = Number($stateParams.year || lastMonthMoment.year())

    $scope.months = [
        { value: 1, label: 'Janvier' },
        { value: 2, label: 'Février' },
        { value: 3, label: 'Mars' },
        { value: 4, label: 'Avril' },
        { value: 5, label: 'Mai' },
        { value: 6, label: 'Juin' },
        { value: 7, label: 'Juillet' },
        { value: 8, label: 'Août' },
        { value: 9, label: 'Septembre' },
        { value: 10, label: 'Octobre' },
        { value: 11, label: 'Novembre' },
        { value: 12, label: 'Décembre' },
    ]

    $scope.changeCutoffDate = () => {
        const cutoff_date = moment(`${$scope.cutoffYear}-${$scope.cutoffMonth}`, 'YYYY-M').endOf('month').format('DD/MM/YYYY')
        if ($scope.metaInvoices.instance) {
            const existingFilter = $scope.metaInvoices.instance.filter()
            $scope.metaInvoices.instance.filter = () => _.assign(existingFilter, { cutoff_date })
        } else {
            $scope.metaInvoices.instance = {
                page: () => 1,
                count: () => 25,
                sorting: () => ({}),
                filter: () => _.assign({ cutoff_date }, _.clone($location.search())),
            }
        }
        $scope.refreshInvoices()
    }

    $scope.metaInvoices = {
        refreshing: false,
        show: {},
        counts: [10, 25, 50, 100],
        columns: {
            'selector': { label: 'Sel.', mode: 'filter_only' },
            'id': { label: 'ID', mode: 'search_operator', mandatory: true },
            'category.organization': { label: 'Org.', mode: 'search_wildcard' },
            'id_category': { label: 'ID Paquet', mode: 'search_operator', mandatory: true },
            'category.name': { label: 'Paquet facturier', mode: 'search_wildcard' },
            'status': { label: 'Status', mode: 'search_operator' },
            'category.account.brand': { label: 'Compte', mode: 'search_wildcard' },
            'cutoff_date': { label: 'Date du cutoff', mode: 'search_date', strictDate: true },
            'period_start_date': { label: 'Début', mode: 'search_date' },
            'period_end_date': { label: 'Fin', mode: 'search_date' },
            'error_code': { label: 'Code erreur', mode: 'search_wildcard' },
        },
    }

    $scope.processing = (invoice) => _.some([
        $scope.massOperating,
        invoice.valuating,
    ])

    $scope.toggleSelected = function (invoice, e) {
        e.preventDefault()
        e.stopPropagation()
        invoice.selected = !invoice.selected
    }

    $scope.selectAll = () =>
        _.forEach($scope.metaInvoices.instance.data, (c) => {
            c.selected = true
        })

    $scope.deSelectAll = () =>
        _.forEach($scope.metaInvoices.instance.data, (c) => {
            c.selected = false
            return true
        })

    $scope.getValuables = () =>
        _.map(_.filter($scope.metaInvoices.instance.data, 'selected'), 'id')

    $scope.getSelectedNumber = () => _.countBy($scope.metaInvoices.instance.data, 'selected').true || 0

    const fetchMetaCutoffInvoices = (invoice) => {
        return ApiBilling.fetchMetaCutoffInvoices({ id: invoice.id }).$promise.then((result) => {
            invoice.invoiceCount = result.length
            invoice.invoicesTP = new NgTableParams({ count: 12 }, {
                counts: [],
                dataset: result,
            })
        })
        .catch(ErrorCatcher)
    }

    $scope.refreshInvoice = function (i) {
        const refreshes = []
        refreshes.push(fetchMetaCutoffInvoices(i))
        i.refreshing = true
        return Promise.all(refreshes).then(() => {
            i.fetched = true
            i.refreshing = false
        })
    }

    $scope.toggleExpand = function (invoice) {
        if (!invoice.refreshing) {
            invoice.expanded = !invoice.expanded
            if (!invoice.fetched) {
                $scope.refreshInvoice(invoice)
            }
        }
    }

    EventProcessorService.register('META_STATUS_CHANGED', 'ALL', $scope, (event) => {
        UserNotificationService.addNotif({ msg: event.title })
        const meta = _.find($scope.metaInvoices.instance.data, { id: event.metaInvoiceId })
        if (meta) {
            return DataAccessSearch({ offset: 0, columns: _.without(Object.keys($scope.metaInvoices.columns), 'selector') })
            .searchPaginated({ resource: 'meta-invoices-cutoff', id: event.metaInvoiceId }).$promise
            .then((dataUpdate) => {
                if (dataUpdate && dataUpdate.results && dataUpdate.results.length) {
                    _.assign(meta, dataUpdate.results[0])
                }
            })
        }
    })

    $scope.valuate = (invoice, e) => {
        e.preventDefault()
        e.stopPropagation()
        if ($scope.processing(invoice)) {
            return
        }
        invoice.valuating = true
        return ApiBilling.valuateMetaCutoff({ id_invoice: invoice.id }, {}).$promise.then((result) => {
            AlertManager.success(`Valorisation lancée`)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.valuating = false
            $scope.refreshInvoices()
        })
    }

    // MASS OPERATIONS

    // MASS VALUATE
    $scope.massValuateTemplate = {
        reprocessAll: false,
    }

    $scope.massValuateFields = {
        reprocessAll: {
            label: 'Relancer toutes les valo. des sous-factures',
            type: 'checkbox',
        },
    }

    $scope.massValuate = () => {
        const invoices = $scope.getValuables()
        if (!invoices.length) {
            return
        }
        return ApiBilling.batchValuateMetaInvoice({ invoices, reprocessAll: $scope.massValuateTemplate.reprocessAll, cutoff: true }).$promise.then((result) => {
            AlertManager.success(`Valorisation en masse lancée sur : ${result.number} factures.`)
        })
        .catch(ErrorCatcher)
    }

    $scope.refreshInvoices = () => {
        TableGeneratorService.getTable($scope.metaInvoices, 'meta-invoices-cutoff', null, null, { orderBy: '-id' })
    }

    const activate = $scope.changeCutoffDate

    activate()
})
